<div class="container mt-5 mb-5">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="text-center">
        <h1 class="wait-header">Vent venligst...</h1>
      </div>
    </div>
  </div>
</div>
